export default "__VITE_ASSET__CSOGzU3G__"